import { createSelector } from "reselect"
import { UIConfigurationApi } from "./UIConfigurationApi"

const COLUMNS_INFO = 'table_columns'

export const getColumnsInfo = (state, props) => state[COLUMNS_INFO] || {}

const getTable = (state, props) => (props.table || '')

export const getDefaultColumnValues = (state, props) => (props.defaultColumnValues || [])

export const getColumnValuesForTable = createSelector(
    getColumnsInfo,
    getTable,
    (columnsInfo, table) => {
        return columnsInfo[table] || []
    }
)

export const getColumnValues = createSelector(
    getColumnValuesForTable,
    getDefaultColumnValues,
    (jobsAndEstimatesColumns, defaultColumnValues) => {
        return buildTitleForColumnValues(defaultColumnValues, jobsAndEstimatesColumns)
    }
)

export function buildTitleForColumnValues(defaultColumnValues, columnValues) {
    let columnsWithTitle = []

    defaultColumnValues.forEach((value) => {
        const columnValueFromServer = columnValues.find((columnValue) => columnValue.name === value.name )
        const defaultColumnValueCopy = { ...value }
        columnsWithTitle.push(Object.assign(defaultColumnValueCopy, columnValueFromServer))
    })

    return columnsWithTitle
}

export const getColumnsInfoNamespace = () => (COLUMNS_INFO)

export const fetchColumnsHash = {
    fetchingApiFunc: UIConfigurationApi.getUIConfiguration,
    selector: getColumnsInfo,
    paramsFromProps: (props) => ([props.component, props.table]),
    dataNamespace: COLUMNS_INFO
}
